<template>
  <div class="menu-wrapper">
    <router-link to="/">
      <img v-bind="imgOptions">
    </router-link>
    <div class="menu">
      <router-link v-for="{ title, route } of links" :key="title" :to="route">
        <span>{{ title }}</span>
      </router-link>
    </div>
    <div class="menu-xs" @click="open = true">
      <div class="menu-xs-burger">
        <font-awesome-icon icon="fa-solid fa-bars" />
      </div>
    </div>
    <div v-if="open" class="menu-modal">
      <div class="menu-xs-burger" @click="open = false">
        <font-awesome-icon icon="fa-solid fa-x" />
      </div>
      <router-link v-for="{ title, route } of links" :key="title" :to="route" @click="open = false">
        <span>{{ title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import {computed, ref} from 'vue'
import { useWindowSize } from '@vueuse/core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'HeaderMenu',
  components: {FontAwesomeIcon},
  setup() {
    const { width } = useWindowSize()

    const open = ref(false)

    const links = [
      {
        title: 'Рассчитать стоимость',
        route: { name: 'order-create' }
      },
      {
        title: 'Отследить груз',
        route: { name: 'manage' }
      },
      {
        title: 'География',
        route: { name: 'geo' }
      },
      {
        title: 'Документы',
        route: { name: 'documents' }
      },
      {
        title: 'Контакты',
        route: { name: 'contacts' }
      },
    ]

    const imgOptions = computed(() => {
      return width.value > 1240
        ? {
          src: require('../assets/logo-text.svg'),
          width: 373,
          height: 60
        }
        : {
          src: require('../assets/logo.svg'),
          width: 70,
          height: 60
        }
    })

    return {
      imgOptions,
      open,
      links,
    }
  }
}
</script>

<style scoped>
.menu-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
}
.menu {
  align-items: center;
  color: white;
  display: flex;
  justify-content: center;
  gap: 30px;
}
.menu-wrapper a {
  display: flex;
  align-items: center;
  color: white;
  font-weight: 700;
  text-decoration: unset;
  text-align: left;
  max-width: 300px;
}

.menu a {
  position: relative;
}
.menu a:hover::after, .menu .router-link-active::after {
  content: '';
  position: absolute;
  bottom: -12px;
  width: 40px;
  height: 4px;
  background-color: var(--primary-color);
}

.menu-xs {
  display: none;
}

.menu-xs-burger {
  font-size: 22px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  border: 1px solid;
  border-radius: 10px;
  cursor: pointer;
}

.menu-modal {
  z-index: 1000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #4A4949;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
}
.menu-modal a {
  color: white;
  text-decoration: unset;
}

.menu-modal .menu-xs-burger {
  position: absolute;
  right: 8px;
  top: 20px;
}

@media screen and (max-width: 1200px) {
  .menu {
    flex-wrap: wrap;
    column-count: 2;
    height: unset;
  }
}

@media screen and (max-width: 768px) {
  .menu {
    display: none;
  }
  .menu-xs {
    display: block;
  }
}
</style>
